export default "__VITE_ASSET__BJf6TqTV__"